<template>
  
  <section class="product">
    
    <div class="container">
      
      <div class="product__cards">
        
        <Card  v-for="(product, index) in products" :key="index" :product="product" />
        
      </div>
      
    </div>
    
  </section>
  
</template>

<script>
import { mapState } from 'vuex'
import Card from "@/components/Card/Card";


export default {
  name: "Products",
  components: {
    Card
  },
  computed: {
    ...mapState(["products"])
  },
  created() {
    this.$store.dispatch("getProducts")
  },
}

</script>